import type { MyBetsResponse } from '@ps/isp-web-services-types';

import type { ExtractDispatchFromModel, ExtractSelectFromModel } from '@swf/core/store';
import type { LiveOption } from '@swf/sports/types/liveOption';

import type { SportsMyBetsWidgetModel } from '.';

export type WidgetDispatch = ExtractDispatchFromModel<SportsMyBetsWidgetModel>;
export type WidgetSelect = ExtractSelectFromModel<SportsMyBetsWidgetModel>;

export interface CashOutBetState {
  cashOutError?: string;
  isAwaitingCashOutConfirmation?: boolean;
  isSubmittingCashOut?: boolean;
}

export type CashOutBets = Record<string, CashOutBetState>;

export interface SportsMyBetsState {
  bets: MyBetsResponse['bets'];
  cashOutQuotes: MyBetsResponse['cashoutQuotes'];
  cashedOut: Record<string, number | undefined>;
  showLoader: boolean;
  moreAvailable?: boolean;
  numberOfMatches?: number;
  isErroneous: boolean;
  isSettled?: boolean;
  cashOutBets: CashOutBets;
  pollingInterval: number;
  isLoadingMoreBets: boolean;
  selectedLiveOption: {
    id?: string;
    accordionIds?: string[];
    liveOption?: LiveOption;
  };
}

export interface SearchBetsQuery {
  isSettled?: boolean;
  sortDir?: SortDirType;
  sortParam?: SortParamType;
  fromRecord?: number;
  toRecord?: number;
}

export enum SortDirType {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum SortParamType {
  PLACEMENT_DATE = 'PLACEMENT_DATE',
  SETTLEMENT_DATE = 'SETTLEMENT_DATE',
  CLOSEST_START_TIME = 'CLOSEST_START_TIME'
}
